import React from 'react';

import Typography from '../../library/typography/typography';
import { CheckSolidIcon, TimesSolidIcon } from '../../shared/icons/icons';

import { ArticleAvailiabityStatusEnum } from '../../shared/types/graphql-types';
import { ARTICLE_STATUSES } from '../../shared/constants/products';

import './product-article-status-label.scss';

interface ProductArticleStatusLabelProps {
  articleStatus: ArticleAvailiabityStatusEnum;
}

function ProductArticleStatusLabel(props: ProductArticleStatusLabelProps) {
  const { articleStatus } = props;

  return (
    <Typography styleName="label">
      {articleStatus === ARTICLE_STATUSES.PRE_LAUNCH && (
        <>
          <CheckSolidIcon styleName="prelaunch-icon" />
          Coming Soon -
        </>
      )}
      {articleStatus === ARTICLE_STATUSES.DISCONTINUED && (
        <>
          <TimesSolidIcon styleName="discontinued-icon" />
          Discontinued -
        </>
      )}
    </Typography>
  );
}

export default ProductArticleStatusLabel;
